(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["home-deliciou-featured"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
     $('.delicius-feature_slider').owlCarousel({
       loop:true,
       margin:0,
       autoplay:true,
       nav: true,
       responsive:{
         0:{
           items:1
         },
		 320:{
           items:2
         },
         769:{
           items:3
         },
         1000:{
           items:5
         }
       }
     }); 
  }); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-product-info"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
     $('.information-slider').owlCarousel({
       loop:true,
       margin:30,
       nav:false,
       autoplay:true,
       items:3,
       autoplayHoverPause:true,
       responsive:{
         0:{
           items:1
         },
         600:{
           items:1
         },
         1000:{
           items:1
         }
       }
     }); 
  }); 

  } catch(e) { console.error(e); }
})();

})();
